import { ReactComponent as Autocaravanas } from '../assets/icons/tipo/autocaravanas.svg';
import { ReactComponent as Tractor } from '../assets/icons/tipo/tractor.svg';
import { ReactComponent as MobileHomes } from '../assets/icons/tipo/mob.svg';
import { ReactComponent as Comercial } from '../assets/icons/tipo/comerc.svg';
import { ReactComponent as Berlina } from '../assets/icons/tipo/berlina.svg';
import { ReactComponent as Motos } from '../assets/icons/tipo/motos.svg';
import { ReactComponent as Barcos } from '../assets/icons/tipo/tipo_barco.svg';
import { ReactComponent as Classico } from '../assets/icons/tipo/class.svg';
import { ReactComponent as Vendido } from '../assets/icons/tipo/vendido.svg';
import { ReactComponent as Lowcost } from '../assets/icons/tipo/lowcost.svg';
import { ReactComponent as Retoma } from '../assets/icons/tipo/retoma.svg';
import { ReactComponent as Atrelado } from '../assets/icons/tipo/atrelado.svg';
import { ReactComponent as Pecas } from '../assets/icons/tipo/pecas.svg';
import { ReactComponent as Motores } from '../assets/icons/tipo/motores.svg';
import { ReactComponent as Novos } from '../assets/icons/tipo/novos.svg';

export const combEletricos = [41, 39, 57, 58, 60, 61];
export const carrosComerciais = [
  46, 86, 59, 60, 61, 64, 65, 66, 87, 88, 89, 114, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105,
  106, 107, 108, 109, 111, 112, 113, 117, 119,
];
export const carrosAutocaravanas = [68, 91];
export const mobileHomes = [123];
export const tractor = [110];

//tipo mota e barco
export const motas = [90];
export const barcos = [93];
export const viaturas_alias = { motos: 'motas' };


/**
 * Normalizes the vehicle type slug to a standard alias if available.
 * @param {string} [slug=''] - The slug representing the vehicle type.
 * @returns {string} - The normalized vehicle type alias or the original slug if no alias is found.
 */

export const normalizarViatura = (slug = '') => {
  const key = String(slug).toLowerCase().trim();
  return viaturas_alias[key] ?? slug;
};


//estado mota nova
export const motasNova = [40];

export const CaixaManual = [33, 34, 35, 40, 42];
export const CaixaAutomatica = [32, 36, 37, 38, 39, 41, 43, 44];

export const viaturasConfig = {
  automoveis: {
    filter: viatura => true,
    Dispatch: 'AddCarros',
    svg: Berlina,
    state: 'allCarros',
    titulo: 'Automóveis',
    ordenar: 1,
    existe: true,
  },
  campanhas: {
    filter: viatura =>
      viatura.Viatura === 'carros' &&
      viatura.NaoExportarPreco !== true &&
      viatura.PrecoPromoLimpo !== '' &&
      viatura.Vendido !== true,
    Dispatch: 'AddCampanhas',
    svg: Novos,
    state: 'allCampanhas',
    titulo: 'Campanha',
    ordenar: 13,
    existe: false,
  },
  comerciais: {
    filter: viatura => viatura.Viatura === 'carros' && carrosComerciais.includes(viatura.Tipo.Id),
    Dispatch: 'AddComercias',
    svg: Comercial,
    state: 'allComercias',
    titulo: 'Comerciais',
    ordenar: 2,
    existe: true,
  },
  classicos: {
    filter: viatura => viatura.Estado.Id === 41 && viatura.Viatura === 'carros',
    Dispatch: 'AddClassicos',
    svg: Classico,
    state: 'allClassicos',
    titulo: 'Clássicos',
    ordenar: 3,
    existe: true,
  },
  motas: {
    filter: viatura => {
      const result =
        viatura.Viatura === 'motas' ||
        (viatura.Viatura === 'carros' && motas.includes(viatura.Tipo.Id));

      return result;
    },
    Dispatch: 'AddMotas',
    svg: Motos,
    state: 'allMotas',
    titulo: 'Motos',
    ordenar: 4,
    existe: true,
  },
  'motas-novas': {
    filter: viatura =>
      (viatura.Viatura === 'motas' && motasNova.includes(viatura.Estado.Id)) ||
      (viatura.Viatura === 'carros' &&
        motas.includes(viatura.Tipo.Id) &&
        motasNova.includes(viatura.Estado.Id)),
    Dispatch: 'AddMotasNovas',
    svg: Motos,
    state: 'allMotasNovas',
    titulo: 'Motos Novas',
    ordenar: 4,
    existe: false,
  },
  barcos: {
    filter: viatura =>
      viatura.Viatura === 'barcos' ||
      (viatura.Viatura === 'carros' && barcos.includes(viatura.Tipo.Id)),
    Dispatch: 'AddBarcos',
    svg: Barcos,
    state: 'allBarcos',
    titulo: 'Barcos',
    ordenar: 5,
    existe: true,
  },
  pecas: {
    filter: viatura => viatura.Viatura === 'pecas',
    Dispatch: 'AddPecas',
    svg: Pecas,
    state: 'allPecas',
    titulo: 'Peças',
    ordenar: 5,
    existe: true,
  },
  atrelados: {
    filter: viatura => viatura.Viatura === 'atrelados',
    Dispatch: 'AddAtrelados',
    svg: Atrelado,
    state: 'allAtrelados',
    titulo: 'Atrelados',
    ordenar: 5,
    existe: false,
  },
  motores: {
    filter: viatura => viatura.Viatura === 'motores',
    Dispatch: 'AddMotores',
    svg: Motores,
    state: 'allMotores',
    titulo: 'Motores',
    ordenar: 5,
    existe: false,
  },
  autocaravanas: {
    filter: viatura =>
      viatura.Viatura === 'carros' && carrosAutocaravanas.includes(viatura.Tipo.Id),
    Dispatch: 'AddAutocaravanas',
    svg: Autocaravanas,
    state: 'allAutocaravanas',
    titulo: 'Autocaravanas',
    ordenar: 6,
    existe: false,
  },
  'mobile-home': {
    filter: viatura => viatura.Viatura === 'carros' && mobileHomes.includes(viatura.Tipo.Id),
    Dispatch: 'AddMobileHomes',
    svg: MobileHomes,
    state: 'mobileHomes',
    titulo: 'Mobile Home',
    ordenar: 7,
    existe: false,
  },
  tractor: {
    filter: viatura => viatura.Viatura === 'carros' && tractor.includes(viatura.Tipo.Id),
    Dispatch: 'AddTractor',
    svg: Tractor,
    state: 'allTractor',
    titulo: 'Tractor',
    ordenar: 8,
    existe: false,
  },
  'low-cost': {
    filter: viatura => viatura.Estado.Id === 43 && viatura.Viatura === 'carros',
    Dispatch: 'AddLowcost',
    svg: Lowcost,
    state: 'allLowcost',
    titulo: 'Low-Cost',
    ordenar: 9,
    existe: false,
  },
  retomas: {
    filter: viatura => viatura.Estado.Id === 37 && viatura.Viatura === 'carros',
    Dispatch: 'AddRetoma',
    svg: Retoma,
    state: 'allRetoma',
    titulo: 'Retoma',
    ordenar: 10,
    existe: false,
  },
  novos: {
    filter: viatura => viatura.Estado.Id === 40 && viatura.Viatura === 'carros',
    Dispatch: 'AddNovos',
    svg: Novos,
    state: 'allNovos',
    titulo: 'Novos',
    ordenar: 11,
    existe: false,
  },
  vendidos: {
    filter: viatura => viatura.Vendido === true,
    Dispatch: 'AddVendidos',
    svg: Vendido,
    state: 'allVendidos',
    titulo: 'Vendidos',
    ordenar: 12,
    existe: false,
  },
};
